import { Button, Col, Form, Modal } from 'react-bootstrap'
import React from 'react'
import ButtonLoading from '../../../components/button/ButtonLoading'
import { Controller, useForm } from 'react-hook-form'
import {
  NotificationDispatch,
  NotificationType,
} from '../../../shared/models/notification.model'
import { useAddNotificationDispatchMutation } from '../../../store/kopiliot-api/notification-dispatch'
import SelectBase from '../../../components/page-components/selects-entities/generic-select/SelectBase'
import { SelectableValue } from '../../../components/page-components/selects-entities/generic-select/selectable-value'
import { useLazyGetNotificationTemplatesQuery } from '../../../store/kopiliot-api/notification-template'
import { NotificationTemplateID } from '../../../shared/models/id/notification_template_id'
import { NotificationRecipientID } from '../../../shared/models/id/notification-recipient-i-d'
import { useLazyGetNotificationRecipientsQuery } from '../../../store/kopiliot-api/notification-recipient'
import { MultiSelect } from '../../../components/page-components/selects-entities/generic-select/Select'
import { CustomerId } from '../../../shared/models/id/customer-id'

interface Props {
  show?: boolean
  onHide?: () => void
}

const SendNotification: React.FC<Props> = ({ show, onHide }) => {
  const [templateOptions, setTemplateOptions] = React.useState<
    SelectableValue<NotificationTemplateID>[] | undefined
  >(undefined)
  const [recipientOptions, setRecipientOptions] = React.useState<
    SelectableValue<NotificationRecipientID>[] | undefined
  >(undefined)
  const form = useForm<Partial<NotificationDispatch>>({
    defaultValues: {
      recipientIDs: [],
    },
  })
  const {
    control,
    formState: { errors },
  } = form
  const [addDispatch, resultDispatch] = useAddNotificationDispatchMutation()
  const [getTemplates, resultGetTemplates] =
    useLazyGetNotificationTemplatesQuery()
  const [getRecipients, resultGetRecipients] =
    useLazyGetNotificationRecipientsQuery()
  React.useEffect(() => {
    setTemplateOptions(
      resultGetTemplates.data?.rows.map((v) => {
        return {
          value: v.id,
          label: v.name,
        }
      })
    )
  }, [resultGetTemplates.data])
  React.useEffect(() => {
    setRecipientOptions(
      resultGetRecipients.data?.rows.map((v) => {
        return {
          value: v.id,
          label: v.name,
        }
      })
    )
  }, [resultGetRecipients.data])
  const isLoading = resultDispatch.isLoading
  const onSubmit = async (data: Partial<NotificationDispatch>) => {
    try {
      await addDispatch(data)
    } catch (e) {
      console.log(e)
    }
  }
  return (
    <Modal show={show} onHide={onHide} size={'xl'} centered>
      <Modal.Header>
        <Modal.Title>Envoyer une notification</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group as={Col} lg={6} md={12}>
          <Form.Label htmlFor={'templateID'}>Template</Form.Label>
          <Controller
            control={control}
            name={'templateID'}
            rules={{ required: 'Please select a template' }}
            render={({ field }) => {
              return (
                <SelectBase
                  isLoading={resultGetTemplates.isLoading}
                  placeholder={'Rechercher...'}
                  options={templateOptions}
                  onInputChange={(value) => {
                    getTemplates({
                      offset: 0,
                      limit: 100,
                      textSearch: value,
                      notificationType: NotificationType.GENERAL,
                    })
                  }}
                  isClearable={true}
                  debounceDelay={1000}
                  minCharsForSearch={2}
                  value={field.value ? { value: field.value } : undefined}
                  onChange={(
                    value: SelectableValue<NotificationTemplateID>
                  ) => {
                    if (value) {
                      field.onChange(value?.value)
                    }
                  }}
                  valueComparator={(a, b) => {
                    return a?.value?.id === b?.value?.id
                  }}
                  errorMessage={errors.templateID?.message}
                />
              )
            }}
          />
        </Form.Group>
        <Form.Group as={Col} lg={6} md={12}>
          <Form.Label htmlFor={'templateID'}>Recipients</Form.Label>
          <Controller
            name={'recipientIDs'}
            control={control}
            render={({ field }) => {
              return (
                <MultiSelect
                  isLoading={resultGetRecipients.isLoading}
                  placeholder={'Rechercher...'}
                  options={recipientOptions}
                  onInputChange={(value) => {
                    getRecipients({
                      offset: 0,
                      limit: 100,
                      textSearch: value,
                    })
                  }}
                  isClearable={true}
                  debounceDelay={2000}
                  minCharsForSearch={2}
                  value={field.value?.map((v: CustomerId) => {
                    return { value: v }
                  })}
                  valueComparator={(a, b) => {
                    console.log('a', a)
                    console.log('b', b)
                    return a?.value?.id === b?.value?.id
                  }}
                  errorMessage={errors.recipientIDs?.message}
                  onChange={(value) => {
                    if (value) {
                      field.onChange(value?.map((v) => v.value))
                    }
                  }}
                />
              )
            }}
          />
        </Form.Group>
        <pre>{JSON.stringify(form.formState)}</pre>
      </Modal.Body>
      <Modal.Footer>
        <Button type={'button'} variant={'outline-secondary'} onClick={onHide}>
          Annuler
        </Button>
        <ButtonLoading
          isLoading={isLoading}
          disabled={isLoading}
          variant={'outline-primary'}
          type={'submit'}
          text={'Valider'}
          onClick={form.handleSubmit(onSubmit)}
        />
      </Modal.Footer>
    </Modal>
  )
}

export default SendNotification
